import styled from 'styled-components'


export const  StyledSliderCarousel = styled.div`
    width: 100%;
    height: 100%;
`;